/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: EmployeesListComponent
 * Purpose		: This component retrieve paged data and performs paging operations
 * Dependency	: EmployeesService
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/

import { Component, HostBinding, EventEmitter, Input, Output, OnInit, ViewChild,
	trigger, transition, animate,
	style, state } from '@angular/core';
import 'rxjs/add/operator/switchMap';
import { Observable } from 'rxjs/Observable';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { ToastsManager }  from 'ng2-toastr';

import myGlobals = require('../globals');
import { EmployeesData, EmployeesService } from './Employees.service';
import { EmployeesSearchComponent }  from './EmployeesSearch.component';

@Component({
	selector: 'my-Employees',
	template: require('./EmployeesList.component.html'),
	providers: [EmployeesService],
	animations: [
    trigger('routeAnimation', [
      state('*',
        style({
          opacity: 1,
          transform: 'translateX(0)'
        })
      ),
      transition(':enter', [
        style({
          opacity: 0,
          transform: 'translateX(-100%)'
        }),
        animate('0.4s ease-in')
      ]),
      transition(':leave', [
        animate('0.7s ease-out', style({
          opacity: 0,
          transform: 'translateY(100%)'
        }))
      ])
    ])
  ]
})

export class EmployeesListComponent implements OnInit {
	@HostBinding('@routeAnimation') get routeAnimation() {
		return true;
	}

	@HostBinding('style.display') get display() {
		return 'block';
	}
	
	EmployeesList: EmployeesData[];
	newEmployees: EmployeesData;
	selectedEmployees: EmployeesData;
	errorMessage: string;
	messages: string[];
	showAdd: boolean;
	@ViewChild(EmployeesSearchComponent) filterComponent: EmployeesSearchComponent;

	sortExpression: string = "EmployeeID";
	filterExpression: string = "";
	pageIndex: number = 1;
	pageSize: number = 10;
	endRowIndex: number;
	rowsCount: number;
	pageCount: number;
	isFirstPage: boolean;

    private selectedId: string;

	constructor(
		private EmployeesService: EmployeesService,
		private route: ActivatedRoute,
		private router: Router,
		private toastr: ToastsManager
	) {
		this.newEmployees = new EmployeesData();
		this.pageSize = myGlobals.pageSize;
	}

	ngOnInit() {
		//this.EmployeesService.getAll().subscribe(record => this.EmployeesList=record);
		this.pageIndex = 1;
		this.isFirstPage = true;
		this.getEmployeesByPaging();

		/*
		this.EmployeesList = this.route.params
			.switchMap((params: Params) => {
				this.selectedId = +params['id'];
				return this.service.getAll();
			});
		*/
	}

	// Get all records
	public getEmployees() {
		this.EmployeesService.getAll()
			.subscribe(data => this.EmployeesList = data,
		error =>  this.errorMessage = 'There was an error while retrieving records. Error: ' + <any>error);
	}
	
	// On Search CLick on EmployeesSearch Component
	onSearch(searchText: string) {
		// 1. Update this.filterExpression
		this.filterExpression = searchText;

		// 2. call getEmployeesByPaging method that will refresh the data
		this.pageIndex = 1;
		this.getEmployeesByPaging();
	}
	
	onSort(event, sortColumn: string)
	{
		// var target = event.target || event.srcElement || event.currentTarget;
		// var parent = target.parentNode;
		if (this.sortExpression === sortColumn)
			this.sortExpression = sortColumn + ' desc';
		else if (this.sortExpression === sortColumn + ' desc')
			this.sortExpression = sortColumn;
		else
			this.sortExpression = sortColumn;
		this.getEmployeesByPaging();
	}
	
	// Get records by paging
	getEmployeesByPaging() {
		this.EmployeesService.getAllByPaging(this.filterExpression, this.sortExpression, this.pageIndex, this.pageSize)
			.subscribe(data => {
				this.EmployeesList=data.EmployeesList;
				this.rowsCount=data.RowsCount;
				this.pageCount= Math.ceil(this.rowsCount / this.pageSize);
				if (this.pageIndex == 1)
					this.isFirstPage = true;
				else
					this.isFirstPage = false;
				if (this.pageIndex == this.pageCount)
					this.endRowIndex = this.rowsCount;
				else
					this.endRowIndex = this.pageIndex * this.pageSize;
			},
			error =>  this.errorMessage = 'There was an error while retrieving records. Error: ' + <any>error
		);
	}

	// Adds new record
	addEmployees() {
		this.EmployeesService.addEmployeesData(this.newEmployees).subscribe(record => console.log(record));
		this.getEmployees();
	}

	// Updates existing record
	updateEmployees() {
		this.EmployeesService.updateEmployeesData(this.selectedEmployees).subscribe(record => console.log(record));
		this.getEmployees();
	}

	// Deletes record with specified id
	deleteEmployees(id: string) {
		if (window.confirm('Are you sure you want to delete this Employees?') == true)
		{
			this.EmployeesService.deleteEmployees(id)
			.subscribe(data => this.getEmployees(),
			error =>  this.errorMessage = 'There was an error while deleting record. Error: ' + <any>error,
				() => { 
					this.toastr.success('Employees record deleted successfully...', 'Delete Employees');
					console.log('Employees record deleted successfully...'); 
				}
			);
		}
	}

	// Go to First Page
	onFirstPage() {
		this.pageIndex = 1;
		this.getEmployeesByPaging();
	}

	// Go to Previous Page
	onPreviousPage() {
		if (this.pageIndex > 1) {
			this.pageIndex = this.pageIndex - 1;
			this.getEmployeesByPaging();
		}
	}

	// Refresh - Go to First Page
	onRefresh() {
		this.onFirstPage();
	}

	// Go to Next Page
	onNextPage() {
		if (this.pageIndex < this.pageCount) {
			this.pageIndex = this.pageIndex + 1;
			this.getEmployeesByPaging();
		}
	}

	// Go to Last Page
	onLastPage() {
		this.pageIndex = this.pageCount;
		this.getEmployeesByPaging();
	}

	// On Edit - Go to Edit page
	onSelect(item: EmployeesData) {
		this.router.navigate(['/Employees', item.EmployeeID]);
	}

	// On Details - Go to Details page
	onSelectDetails(item: EmployeesData) {
		this.router.navigate(['/Employees/Details', item.EmployeeID]);
	}

	// Set record as selected
	SelectEmployees(item: EmployeesData) {
		this.selectedEmployees = item;
	}

	// Submits form
	submitForm(data: Object) {
		console.log(data);
	}

	// Logs message onto Console
	log(msg: string) {
		this.messages.splice(0, 0, msg);
		console.log(msg);
	}
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/Employees/EmployeesList.component.ts